
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";


export default function SiteDash({site, position}) {
    // states
    const {user} = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={site.photo !== null ? site?.photo : "/assets/imgs/blank.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{site?.nomuser} {site?.prenom}</div>
                        <div className="widget-subheading">{site?.email}</div>
                    </div>
                </div>
            </td>
            <td>{site?.nom}</td>
            <td>
                <span 
                    className={`badge ${
                        site.etat === 1 ? "badge-warning" : 
                        site.etat === 2 ? "badge-success" : 
                        (site.etat === 3 || site.etat === 4) ? "badge-danger" : 
                        ""
                        } mt-2`
                    } 
                    style={{fontSize: 14}}>
                        {site?.etatdef}
                </span>
            </td>
            <td className="text-center">
                {(user?.isFullAction || user?.isAdminAction || user?.isConsulterSite) && 
                    <Link to={`/site/${site?.code}`} data-toggle="tooltip" title={textes.fr.viewsitelabel} data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                        <i className="fa fa-eye"></i>
                    </Link>
                }
            </td>
        </tr>
    )
}